import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import Button from "../../shared/Button";
import { ResetTicketDialogProps } from "../../../interface/dialog/ResetTicketDialogProps";
import { useDialogStyles } from "../../shared/dialog/styles";

const ResetTicketDialog: React.FC<ResetTicketDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const classes = useDialogStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h5">Reset Ticket?</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="subtitle1" color="textSecondary">
          This will discard all unsaved changes and revert the ticket to its
          original state. Are you sure you want to continue?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            variant="contained"
            color="default"
            onClick={onClose}
            type="button"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Reset Ticket"
            variant="contained"
            color="secondary"
            onClick={onConfirm}
            type="button"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ResetTicketDialog;
